export default __webpack_public_path__ + "static/media/link-navi.884a0837.png";